import { Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import thubmWhite from 'styles/assets/thumb_white.webp';

export const AppBarPromotion = () => {
  const { t } = useTranslation('app');

  return (
    <div style={{ backgroundColor: '#324996', paddingTop: '30px', textAlign: '-webkit-center' }}>
      <div className="top-bar" style={{ textAlign: 'left' }}>
        <Grid container>
          <Grid size={{ xs: 2, sm: 1 }}>
            <img src={thubmWhite} width="70%" alt="thumb" />
          </Grid>
          <Grid size={{ xs: 10, sm: 11 }}>
            <Typography
              variant="h5"
              color="primary"
              style={{ fontWeight: 'bolder', lineHeight: '6vh' }}
            >
              {t('general.triibo_secure_environment')}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default AppBarPromotion;
